import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ComponentProxy, ComponentProxyDirective } from '@frontend/sports/deferred/feature/component-loader';

@Component({
    selector: 'ms-popup-proxy',
    template: ` <ng-container [msComponentProxy]="proxy" (componentLoaded)="onComponentLoaded()" />`,
    imports: [ComponentProxyDirective],
})
export class PopupProxyComponent {
    @Input() proxy?: ComponentProxy;

    @Output() readonly componentLoaded = new EventEmitter<void>();

    onComponentLoaded(): void {
        this.componentLoaded.next();
    }
}
